import { Link } from "react-router-dom";
import henImg from "../../assets/images/hen.png";

export default function AuthLayout({ eyebrow, title, subtitle, children }) {
  return (
    <div className="auth-page">
      <div className="auth-orb orb-one" />
      <div className="auth-orb orb-two" />
      <header className="auth-header">
        <Link to="/login" className="auth-brand">
          <span className="brand-symbol">✦</span>
          <span>
            CHICKEN <strong>ROAD</strong>
          </span>
        </Link>
        <span className="auth-header-side">
          <span className="online-dot" /> THE ROAD IS OPEN
        </span>
      </header>
      <main className="auth-shell">
        <section className="auth-intro">
          <div className="auth-kicker">
            <span className="kicker-line" /> A PREMIUM EXPERIENCE
          </div>
          <div className="auth-wheel">
            <div className="auth-wheel-inner">
              <img src={henImg} alt="Chicken" />
              <small>CHICKEN ROAD</small>
            </div>
          </div>
          <h2>
            Every step.
            <br />
            <em>A bigger multiplier.</em>
          </h2>
          <p>
            Your chicken is ready to cross the road. Sign in, pick a difficulty and
            cash out before the fire.
          </p>
          <div className="auth-intro-footer">
            <span>✧ PREMIUM INTERFACE</span>
            <span>✧ ALWAYS ON</span>
          </div>
        </section>
        <section className="auth-card">
          <div className="auth-card-top">
            <span className="auth-eyebrow">{eyebrow}</span>
            <span className="auth-step">✦</span>
          </div>
          <h1>{title}</h1>
          <p className="auth-subtitle">{subtitle}</p>
          {children}
          <div className="auth-card-footer">
            SECURE ACCOUNT ACCESS <span>✦</span> CHICKEN ROAD
          </div>
        </section>
      </main>
      {/* <footer className="auth-site-footer">
        © {new Date().getFullYear()} Chicken Road{" "}
        <span>Crafted for a seamless experience</span>
      </footer> */}
    </div>
  );
}
